module.exports = __webpack_public_path__ + "img/4-3.bafc8981.svg";